module.exports = __webpack_public_path__ + "img/hr-puberty-decal-01.93430aed.png";